<template>
  <div style="display: flex">
    <template v-for="channel in channelList">
      <div :key="channel.value" class="channel" :class="channel.status" style="padding: 2px">
        <em
          :class="channel.icon"
          :style="{ color: channel.status == 'active' ? channel.color : '#eee' }"
        ></em>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'AvailableMultipleChannel',
  props: ['messages'],
  data() {
    return {}
  },
  computed: {
    channelList() {
      return this.conversationSocialChannelOptions.map((item) => {
        return {
          ...item,
          status:
            Object.prototype.hasOwnProperty.call(this.messages, `${item.value}_answers`) &&
            this.messages[`${item.value}_answers`] &&
            this.messages[`${item.value}_answers`].length > 0 &&
            this.messages[`${item.value}_answers`][0].length > 0
              ? 'active'
              : 'inactive'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/AvailableMultipleChannel.vue